// Utility functions for meal plan validation

export function getMealPlanStartDate(mealPlan) {
  if (!mealPlan || !mealPlan.dateValid) return null;
  const validDate = new Date(mealPlan.dateValid);
  if (mealPlan.formattedStart) {
    const [startHour, startMinute] = mealPlan.formattedStart.split(":");
    validDate.setHours(startHour, startMinute, 0, 0);
  } else {
    validDate.setHours(0, 0, 0, 0);
  }
  return validDate;
}

export function isMealPlanValid(mealPlan) {
  if (!mealPlan) return false;
  const currentTime = new Date();
  const mealPlanStartDate = getMealPlanStartDate(mealPlan);
  return currentTime < mealPlanStartDate;
}

export function isMealPlanOrderingEnabled() {
  return window.config?.MEAL_PLAN?.withOrdering !== false;
}

// Returns an object mapping groupId to the total quantity of products in that group
export function getGroupProductCounts(basketItems) {
  const groupCounts = {};
  if (basketItems && Array.isArray(basketItems)) {
    basketItems.forEach(item => {
      let groupId = null;
      if (item.extendedInfos) {
        try {
          const ext = typeof item.extendedInfos === 'string' ? JSON.parse(item.extendedInfos) : item.extendedInfos;
          groupId = ext?.mealPlan?.groupId;
        } catch {
          groupId = item.groupId;
        }
      } else {
        groupId = item.groupId;
      }
      if (!groupId) return;
      const quantity = Number(item.quantity) || 0;
      if (!groupCounts[groupId]) groupCounts[groupId] = 0;
      groupCounts[groupId] += quantity;
    });
  }
  return groupCounts;
}

// Returns the max available for a product in a group, considering current basket and group max
export function getGroupMaxAvailable(groupId, productId, basketItems, mealPlanGroups) {
  const groupCounts = getGroupProductCounts(basketItems);
  const group = mealPlanGroups?.find(g => g.id === groupId);
  if (!group) return 0;
  const max = group.maxProducts || 0;
  const used = groupCounts[groupId] || 0;
  // Find current product's quantity in basket (sum all matching groupId+productId)
  let current = 0;
  if (basketItems && Array.isArray(basketItems)) {
    basketItems.forEach(i => {
      let itemGroupId = null;
      if (i.extendedInfos) {
        try {
          const ext = typeof i.extendedInfos === 'string' ? JSON.parse(i.extendedInfos) : i.extendedInfos;
          itemGroupId = ext?.mealPlan?.groupId || i.groupId;
        } catch {
          itemGroupId = i.groupId;
        }
      } else {
        itemGroupId = i.groupId;
      }
      if (itemGroupId === groupId && i.prodId === productId) {
        current += Number(i.quantity) || 0;
      }
    });
  }
  // Allow increment up to group max, considering current product's own quantity
  return Math.max(0, max - used + current);
}

// Returns the max available for a product in a group, considering current basket and group max
export function getMaxAvailableForProduct(groupId, productId, basketItems, mealPlanGroups) {


  return getGroupMaxAvailable(groupId, productId, basketItems, mealPlanGroups);
}

// Returns an object mapping groupId to the remaining count (maxProducts - current quantity in basket, never less than 0)
export function getGroupRemainingCounts(basketItems, mealPlanGroups) {
  const groupCounts = getGroupProductCounts(basketItems);
  const result = {};
  if (Array.isArray(mealPlanGroups)) {
    mealPlanGroups.forEach(group => {
      const max = group.maxProducts || 0;
      const used = groupCounts[group.id] || 0;
      result[group.id] = Math.max(0, max - used);
    });
  }
  return result;
}
